export default __webpack_public_path__ + "static/media/01.f39cd21d.webp";